import { render } from "./ReferenceAdmin.vue?vue&type=template&id=48e00f03"
import script from "./ReferenceAdmin.vue?vue&type=script&lang=js"
export * from "./ReferenceAdmin.vue?vue&type=script&lang=js"

import "./ReferenceAdmin.vue?vue&type=style&index=0&id=48e00f03&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__